/**
 * Utility functions for WhatsApp integration
 */

/**
 * Detect if user is on mobile device
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Open WhatsApp with optimized behavior based on device type
 * @param {string} phoneNumber - WhatsApp phone number (with country code, no +)
 * @param {string} message - Pre-filled message
 */
export const openWhatsApp = (phoneNumber, message) => {
  const encodedMessage = encodeURIComponent(message);

  if (isMobileDevice()) {
    // Mobile: Use wa.me which directly opens WhatsApp app
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.location.href = whatsappUrl;
  } else {
    // Desktop: Try multiple methods to minimize prompts

    // Check if user has previously set a preference
    const savedPreference = localStorage.getItem('whatsapp_open_method');

    if (savedPreference === 'desktop_app') {
      // User prefers desktop app - use protocol handler
      openDesktopApp(phoneNumber, encodedMessage);
    } else if (savedPreference === 'web') {
      // User prefers web version
      openWeb(phoneNumber, encodedMessage);
    } else {
      // First time or no preference - try desktop app first
      // This will show browser permission dialog ONCE
      openDesktopApp(phoneNumber, encodedMessage);

      // Save preference after first use
      localStorage.setItem('whatsapp_open_method', 'desktop_app');
    }
  }
};

/**
 * Open WhatsApp Desktop app using protocol handler
 */
const openDesktopApp = (phoneNumber, encodedMessage) => {
  const desktopProtocolUrl = `whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`;

  // Try using window.location for better protocol handler support
  window.location.href = desktopProtocolUrl;
};

/**
 * Open WhatsApp Web in browser
 */
const openWeb = (phoneNumber, encodedMessage) => {
  const webUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
  window.open(webUrl, '_blank', 'noopener,noreferrer');
};

/**
 * Get WhatsApp enrollment URL
 * @param {string} phoneNumber - WhatsApp phone number
 * @param {string} message - Pre-filled message
 * @returns {string} - WhatsApp URL
 */
export const getWhatsAppUrl = (phoneNumber, message) => {
  const encodedMessage = encodeURIComponent(message);

  if (isMobileDevice()) {
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  } else {
    return `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
  }
};
